import React from 'react';

import { AvailableInternalLinkMenuItem } from '../../../../../providers/NavigationProvider/types';
import { SideNavLabel } from '../../SideNavLabel';
import {
  StyledBaseListItem,
  StyledBlockedLink,
  StyledSideNavLevelTwoListItem,
  StyledSideNavLevelTwoNavLink,
} from './SideNavLevelTwoLink.styles';

type SideNavLevelTwoLinkProps = {
  exact: boolean;
  isActiveRoute: boolean;
  isBlocked: boolean;
  routePath: string;
  menuItemConfig: AvailableInternalLinkMenuItem;
  preventFocus: boolean | undefined;
};

export const SideNavLevelTwoLink = ({
  exact,
  isActiveRoute,
  isBlocked,
  routePath,
  menuItemConfig,
  preventFocus,
}: SideNavLevelTwoLinkProps) => {
  const { label, statusLabel } = menuItemConfig;

  if (isBlocked) {
    return (
      <StyledBaseListItem>
        <StyledBlockedLink>
          <SideNavLabel label={label} statusLabel={statusLabel} />
        </StyledBlockedLink>
      </StyledBaseListItem>
    );
  }

  return (
    <StyledSideNavLevelTwoListItem $isActiveRoute={isActiveRoute}>
      <StyledSideNavLevelTwoNavLink
        to={routePath}
        exact={exact}
        {...(preventFocus && { tabIndex: -1 })}
      >
        <SideNavLabel label={label} statusLabel={statusLabel} />
      </StyledSideNavLevelTwoNavLink>
    </StyledSideNavLevelTwoListItem>
  );
};
